/**
 * WMS ASN (Advance Shipment Notice) Types
 * Shared between backend-wms and mobile-app
 *
 * DRY Compliance: Single source for all ASN enums
 */

/**
 * Status of an ASN
 */
export enum ASNStatus {
  DRAFT = 'DRAFT',
  CONFIRMED = 'CONFIRMED',
  IN_TRANSIT = 'IN_TRANSIT',
  ARRIVED = 'ARRIVED',
  RECEIVED = 'RECEIVED',
  CANCELLED = 'CANCELLED',
}

/**
 * Status labels for UI display
 */
export const ASNStatusLabels: Record<ASNStatus, string> = {
  [ASNStatus.DRAFT]: 'Draft',
  [ASNStatus.CONFIRMED]: 'Confirmed',
  [ASNStatus.IN_TRANSIT]: 'In Transit',
  [ASNStatus.ARRIVED]: 'Arrived',
  [ASNStatus.RECEIVED]: 'Received',
  [ASNStatus.CANCELLED]: 'Cancelled',
};

/**
 * Color schemes for status badges (Chakra UI v3 compatible)
 */
export const ASNStatusColors: Record<ASNStatus, string> = {
  [ASNStatus.DRAFT]: 'gray',
  [ASNStatus.CONFIRMED]: 'blue',
  [ASNStatus.IN_TRANSIT]: 'purple',
  [ASNStatus.ARRIVED]: 'teal',
  [ASNStatus.RECEIVED]: 'green',
  [ASNStatus.CANCELLED]: 'red',
};
